export default class MiroJson {
  version: number;
  host: string;
  isProtected: boolean;
  boardId: string;
  data: MiroData;

  constructor(obj: any) {
    this.version = obj.version;
    this.host = obj.host;
    this.isProtected = obj.isProtected;
    this.boardId = obj.boardId;
    this.data = new MiroData(obj.data);
  }
}

export class MiroData {
  objects: Array<MiroComponent>;
  shift: string;
  meta: any;

  constructor(obj: any) {
    this.objects = obj.objects.map((widget: any) =>
      widget.type == 10 ? new MiroGroup(widget) : new MiroWidget(widget)
    );
    this.shift = obj.shift;
    this.meta = obj.meta;
  }
}

export class MiroComponent {
  id: number;
  initialId: string;
  type: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.initialId = obj.initialId;
    this.type = obj.type;
  }
}

export class MiroGroup extends MiroComponent {
  items: Array<number>;

  constructor(obj: any) {
    super(obj);
    this.items = obj.items;
  }
}

export class MiroWidget extends MiroComponent {
  widgetData: MiroWidgetData;

  constructor(obj: any) {
    super(obj);
    this.widgetData = new MiroWidgetData(obj.widgetData);
  }
}

export class MiroWidgetData {
  json: MiroWidgetDataJsonBase | undefined;
  type: string | undefined;

  constructor(obj: any) {
    if (obj) {
      this.type = obj.type;
      switch (obj.type) {
        case MiroWidgetDataType.frame: {
          this.json = new MiroWidgetDataJsonFrame(obj.json);
          break;
        }
        case MiroWidgetDataType.text: {
          this.json = new MiroWidgetDataJsonText(obj.json);
          break;
        }
        case MiroWidgetDataType.line: {
          this.json = new MiroWidgetDataJsonLine(obj.json);
          break;
        }
        case MiroWidgetDataType.shape: {
          this.json = new MiroWidgetDataJsonShape(obj.json);
          break;
        }
        case MiroWidgetDataType.emoji: {
          this.json = new MiroWidgetDataJsonEmoji(obj.json);
          break;
        }
        case MiroWidgetDataType.sticker: {
          this.json = new MiroWidgetDataJsonSticker(obj.json);
          break;
        }
        case MiroWidgetDataType.paint: {
          this.json = new MiroWidgetDataJsonPaint(obj.json);
          break;
        }
        case MiroWidgetDataType.image: {
          this.json = new MiroWidgetDataJsonImage(obj.json);
          break;
        }
        case MiroWidgetDataType.grid: {
          this.json = new MiroWidgetDataJsonGrid(obj.json);
          break;
        }
        case MiroWidgetDataType.grid_text: {
          this.json = new MiroWidgetDataJsonGridText(obj.json);
          break;
        }
        default: {
          this.json = obj.json;
          break;
        }
      }
    }
  }
}

export class MiroWidgetParent {
  index: number;

  constructor(obj: any) {
    this.index = obj.index;
  }
}

//#region base widget
export class MiroWidgetDataJsonPosition {
  column: string;
  row: string;
  offsetPx: MiroWidgetDataJsonPositionOffsetPx;
  schema: string;

  constructor(obj: any) {
    this.column = obj.column;
    this.row = obj.row;
    this.offsetPx = obj.offsetPx;
    this.schema = obj.schema;
  }
}

export class MiroWidgetDataJsonPositionOffsetPx {
  x: number;
  y: number;

  constructor(obj: any) {
    this.x = obj.x;
    this.y = obj.y;
  }
}

export class MiroWidgetDataJsonScale {
  scale: number;

  constructor(obj: any) {
    this.scale = obj.scale;
  }
}

export class MiroWidgetDataJsonRotation {
  rotation: number;

  constructor(obj: any) {
    this.rotation = obj.rotation;
  }
}

export class MiroWidgetDataJsonSize {
  width: number;
  height: number;

  constructor(obj: any) {
    this.width = obj.width;
    this.height = obj.height;
  }
}

export class MiroDataShift {
  x: number;
  y: number;
  tokenizerIdDesc: string;

  constructor(obj: any) {
    this.x = obj.x;
    this.y = obj.y;
    this.tokenizerIdDesc = obj.tokenizerIdDesc;
  }
}

export class MiroWidgetDataJsonBase {
  _parent: MiroWidgetParent;
  _position: MiroWidgetDataJsonPosition;
  scale: MiroWidgetDataJsonScale;
  relativeScale: number;
  rotation: MiroWidgetDataJsonRotation;
  relativeRotation: number;
  size: MiroWidgetDataJsonSize;

  constructor(obj: any) {
    this._parent = obj._parent;
    this._position = obj._position;
    this.scale = obj.scale;
    this.relativeScale = obj.relativeScale;
    this.rotation = obj.rotation;
    this.relativeRotation = obj.relativeRotation;
    this.size = obj.size;
  }
}
//#endregion

//#region frame widget
export class MiroWidgetDataJsonFrameStyle {
  fs: number;
  ffn: string;
  tc: number;
  ta: string;
  ff: number;
  ss: number;
  sc: number;
  bc: number;
  fo: number;
  fd: number;

  constructor(obj: any) {
    this.fs = obj.fs;
    this.ffn = obj.ffn;
    this.tc = obj.tc;
    this.ta = obj.ta;
    this.ff = obj.ff;
    this.ss = obj.ss;
    this.sc = obj.sc;
    this.bc = obj.bc;
    this.fo = obj.fo;
    this.fd = obj.fd;
  }
}
export class MiroWidgetDataJsonFrame extends MiroWidgetDataJsonBase {
  type: number;
  prevFrameIndex: number;
  x: number;
  y: number;
  width: number;
  height: number;
  style: string;
  text: string;
  boardId: string;
  children: Array<number>;
  isClusteringContainer: boolean;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.type = obj.type;
    this.prevFrameIndex = obj.prevFrameIndex;
    this.x = obj.x;
    this.y = obj.y;
    this.width = obj.width;
    this.height = obj.height;
    this.style = obj.style;
    this.text = obj.text;
    this.boardId = obj.boardId;
    this.children = obj.children;
    this.isClusteringContainer = obj.isClusteringContainer;
  }
}
//#endregion

//#region text widget
export class MiroWidgetDataJsonTextStyle {
  st: number;
  bc: number;
  bo: number;
  bsc: number;
  ta: string;
  tc: number;
  tsc: number;
  ffn: string;
  b: number;
  u: number;
  i: number;
  s: number;
  fw: number;
  brc: number;
  bro: number;
  brw: number;
  brs: number;
  hl: string;

  constructor(obj: any) {
    this.st = obj.st;
    this.bc = obj.bc;
    this.bo = obj.bo;
    this.bsc = obj.bsc;
    this.ta = obj.ta;
    this.tc = obj.tc;
    this.tsc = obj.tsc;
    this.ffn = obj.ffn;
    this.b = obj.b;
    this.u = obj.u;
    this.i = obj.i;
    this.s = obj.s;
    this.fw = obj.fw;
    this.brc = obj.brc;
    this.bro = obj.bro;
    this.brw = obj.brw;
    this.brs = obj.brs;
    this.hl = obj.hl;
  }
}

export class MiroWidgetDataJsonResource {
  id: string;
  width: number;
  height: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.width = obj.width;
    this.height = obj.height;
  }
}

export class MiroWidgetDataJsonGridCell {
  size: number;

  constructor(obj: any) {
    this.size = obj.size;
  }
}

export class MiroWidgetDataJsonGridRootStyle {
  fontFamily: string;

  constructor(obj: any) {
    this.fontFamily = obj.fontFamily;
  }
}

export class MiroWidgetDataJsonGridCellStyle {
  textColor: string;
  fontSize: string;
  textAlign: string;

  constructor(obj: any) {
    this.textColor = obj.textColor;
    this.fontSize = obj.fontSize;
    this.textAlign = obj.textAlign;
  }
}

export class MiroWidgetDataJsonGridRoot {
  columnsOrder: Array<string>;
  rowsOrder: Array<string>;
  columns: Map<string, MiroWidgetDataJsonGridCell>;
  rows: Map<string, MiroWidgetDataJsonGridCell>;
  style: MiroWidgetDataJsonGridRootStyle;
  cellStyles: Map<string, Map<string, MiroWidgetDataJsonGridCellStyle>>;

  constructor(obj: any) {
    this.columnsOrder = obj.columnsOrder;
    this.rowsOrder = obj.rowsOrder;
    this.columns = new Map(Object.entries(obj.columns));
    this.rows = new Map(Object.entries(obj.rows));
    this.style = obj.style;
    this.cellStyles = new Map(
      Object.entries(obj.cellStyles).map(([key, value]: [string, any]) => [
        key,
        new Map(
          Object.entries(value).map(([key, value]: [string, any]) => [key, new MiroWidgetDataJsonGridCellStyle(value)])
        ),
      ])
    );
  }
}

export class MiroWidgetDataJsonGridText extends MiroWidgetDataJsonBase {
  html: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.html = obj.html;
  }
}

export class MiroWidgetDataJsonGrid extends MiroWidgetDataJsonBase {
  gridRoot: MiroWidgetDataJsonGridRoot;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.gridRoot = obj.gridRoot;
  }
}

export class MiroWidgetDataJsonImage extends MiroWidgetDataJsonBase {
  resource: MiroWidgetDataJsonResource;
  style: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.resource = obj.resource;
    this.style = obj.style;
  }
}

export class MiroWidgetDataJsonText extends MiroWidgetDataJsonBase {
  text: string;
  style: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.text = obj.text;
    this.style = obj.style;
  }
}
//#endregion

//#region sticker widget
export class MiroWidgetDataJsonStickerStyle {
  sbc: number;
  fs: number;
  fsa: number;
  ffn: string;
  ta: string;
  tav: string;
  taw: number;
  tah: number;
  lh: number;

  constructor(obj: any) {
    this.sbc = obj.sbc;
    this.fs = obj.fs;
    this.fsa = obj.fsa;
    this.ffn = obj.ffn;
    this.ta = obj.ta;
    this.tav = obj.tav;
    this.taw = obj.taw;
    this.tah = obj.tah;
    this.lh = obj.lh;
  }
}

export class MiroWidgetDataJsonSticker extends MiroWidgetDataJsonBase {
  text: string;
  style: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.text = obj.text;
    this.style = obj.style;
  }
}
//#endregion

//#region line widget
export class MiroWidgetDataJsonLineStyle {
  lc: number;
  ls: number;
  t: number;
  lt: number;
  a_start: number;
  a_end: number;
  VAR: number;
  jump: number;

  constructor(obj: any) {
    this.lc = obj.lc;
    this.ls = obj.ls;
    this.t = obj.t;
    this.lt = obj.lt;
    this.a_start = obj.a_start;
    this.a_end = obj.a_end;
    this.VAR = obj.VAR;
    this.jump = obj.jump;
  }
}

export class MiroWidgetDataJsonLineLineCaptions {
  id: number;
  text: string;
  fontSize: number;
  width: number;
  position: MiroWidgetDataJsonPositionOffsetPx;
  rotated: boolean;
  color: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.text = obj.text;
    this.fontSize = obj.fontSize;
    this.width = obj.width;
    this.position = obj.position;
    this.rotated = obj.rotated;
    this.color = obj.color;
  }
}

export class MiroWidgetDataJsonLineLine {
  captions: Array<MiroWidgetDataJsonLineLineCaptions>;

  constructor(obj: any) {
    this.captions = obj.captions.map((caption: any) => new MiroWidgetDataJsonLineLineCaptions(caption));
  }
}

export class MiroWidgetDataJsonConnectedShape {
  point: MiroWidgetDataJsonPositionOffsetPx;
  positionType: number;
  widgetIndex: number;

  constructor(obj: any) {
    this.point = obj.point;
    this.positionType = obj.positionType;
    this.widgetIndex = obj.widgetIndex;
  }
}

export class MiroWidgetDataJsonLine extends MiroWidgetDataJsonBase {
  points: Array<MiroWidgetDataJsonPositionOffsetPx>;
  primary: MiroWidgetDataJsonConnectedShape;
  secondary: MiroWidgetDataJsonConnectedShape;
  _position: MiroWidgetDataJsonPosition;
  line: MiroWidgetDataJsonLineLine;
  style: string;

  constructor(obj: any) {
    super(obj);
    this.points = obj.points;
    this.primary = obj.primary;
    this.secondary = obj.secondary;
    this._position = obj._position;
    this._parent = obj._parent;
    this.line = obj.line;
    this.style = obj.style;
  }
}
//#endregion

//#region shape widget
export class MiroWidgetDataJsonShapeStyle {
  st: number;
  ss: number;
  sc: number;
  bc: number;
  bo: number;
  brc: number;
  brw: number;
  bro: number;
  brs: number;
  ffn: string;
  tc: number;
  tsc: number;
  ta: string;
  tav: string;
  fs: number;
  b: number;
  i: number;
  u: number;
  s: number;
  bsc: number;
  VER: number;
  hl: number;

  constructor(obj: any) {
    this.st = obj.st;
    this.ss = obj.ss;
    this.sc = obj.sc;
    this.bc = obj.bc;
    this.bo = obj.bo;
    this.brc = obj.brc;
    this.brw = obj.brw;
    this.bro = obj.bro;
    this.brs = obj.brs;
    this.ffn = obj.ffn;
    this.tc = obj.tc;
    this.tsc = obj.tsc;
    this.ta = obj.ta;
    this.tav = obj.tav;
    this.fs = obj.fs;
    this.b = obj.b;
    this.i = obj.i;
    this.u = obj.u;
    this.s = obj.s;
    this.bsc = obj.bsc;
    this.VER = obj.VER;
    this.hl = obj.hl;
  }
}

export class MiroWidgetDataJsonShapeDN {
  element: string;
  collection: string;

  constructor(obj: any) {
    this.element = obj.element;
    this.collection = obj.collection;
  }
}

export class MiroWidgetDataJsonShapeSchemaDataTextsName {
  text: string;

  constructor(obj: any) {
    this.text = obj.text;
  }
}

export class MiroWidgetDataJsonShapeSchemaDataTexts {
  name: MiroWidgetDataJsonShapeSchemaDataTextsName;

  constructor(obj: any) {
    this.name = obj.name;
  }
}

export class MiroWidgetDataJsonShapeSchemaData {
  texts: MiroWidgetDataJsonShapeSchemaDataTexts;

  constructor(obj: any) {
    this.texts = obj.texts;
  }
}

export class MiroWidgetDataJsonShapeSchema {
  id: string;
  data: MiroWidgetDataJsonShapeSchemaData;

  constructor(obj: any) {
    this.id = obj.id;
    this.data = obj.data;
  }
}

export class MiroWidgetDataJsonShape extends MiroWidgetDataJsonBase {
  "ns:diagrammingNotation": MiroWidgetDataJsonShapeDN;
  text: string;
  style: string;
  shape: string;
  type: string;
  schema: MiroWidgetDataJsonShapeSchema;

  constructor(obj: any) {
    super(obj);
    this["ns:diagrammingNotation"] = obj["ns:diagrammingNotation"];
    this._parent = obj._parent;
    this.text = obj.text;
    this.style = obj.style;
    this.shape = obj.shape;
    this.type = obj.type;
    this.schema = obj.schema;
  }
}
//#endregion

//#region emoji widget
export class MiroWidgetDataJsonEmoji extends MiroWidgetDataJsonBase {
  points: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.points = obj.points;
  }
}
//#endregion

//#region paint widget
export class MiroWidgetDataJsonPaintStyle {
  lc: string;
  t: number;
  lo: number;
  e: number;

  constructor(obj: any) {
    this.lc = obj.lc;
    this.t = obj.t;
    this.lo = obj.lo;
    this.e = obj.e;
  }
}

export class MiroWidgetDataJsonPaint extends MiroWidgetDataJsonBase {
  points: Array<MiroWidgetDataJsonPositionOffsetPx>;
  style: string;

  constructor(obj: any) {
    super(obj);
    this._parent = obj._parent;
    this.points = obj.points;
    this.style = obj.style;
  }
}
//#endregion

export enum MiroWidgetDataType {
  frame = 1,
  text,
  line,
  shape,
  emoji,
  sticker,
  image,
  paint,
  grid,
  grid_text,
  stencil,
}

export enum MiroWidgetBasicShapeType {
  rectangle = 3,
  circle = 4,
  triangle = 5,
  bubble = 6,
  roundedRectangle = 7,
  rhombus = 8,

  parallelogram = 10,
  star = 11,
  arrowRight = 12,
  arrowLeft = 13,

  pentagon = 16,
  hexagon = 17,
  octagon = 18,
  trapezoid = 19,
  predefinedProcess = 20,
  arrowLeftRight = 21,
  cloud = 22,
  braceLeft = 23,
  braceRight = 24,
  cross = 25,
  barrel = 26,
}
